// extracted by mini-css-extract-plugin
export default {"root":"cpd-product-autocomplete_root__IN-1g","option":"cpd-product-autocomplete_option__kV3wo","secondary":"cpd-product-autocomplete_secondary__3HtAY"};